import { createFileRoute } from '@tanstack/react-router'
import { Rocket } from 'lucide-react'
import { GettingStartedScreen } from '@/screens/workspace/SCR-185-getting-started'

export const Route = createFileRoute('/_app/w/$ws/getting-started')({
  staticData: { screen: {"id":"SCR-185","title":"Getting started","group":"Workspace","perm":"workspace.read","order":2,"description":"The steps from an empty workspace to agents that remember.", icon: Rocket } },
  component: GettingStartedScreen,
})
